const internship =[
  {
    "image": "https://i.postimg.cc/K8QFJGFw/1705389198122.jpg",
    "title": "Software Developer",
    "company":"Soluperts.ca",
    "duration":"Jan. 2024 - July 2024",
    "location":"Remote, Canada",
    "body":"Implementing the solution using MongoDB, Express.js, React.js,JavaScript and Node.js to create a scalable web system. This includes designing role-based access control, data consolidation, reporting, and user interfaces.Implementing the solution using MongoDB, Express.js, React.js,JavaScript and Node.js to create a scalable web system. This includes designing role-based access control, data consolidation, reporting, and user interfaces.",
    "user_id":1
  },

    {
        "image": "/Images/mantra.jpeg",
        "title": "Software Developer",
        "company":"Holy Basil Matra Pvt. Ltd.",
        "duration":"Aug. 2023 - Oct. 2023",
        "location":"New Delhi,India",
        "body":"I developed the front-end of an ICU digitization website using React and Bootstrap, connected it to the back-end with JavaScript, and resolved Cors errors in the ISAPI Protocol, improving website functionality",
        "user_id":2
      },

      {
        "image":"/Images/cic-du.png",
        "title":"Ecommerce App:thecart",
        "company":"Cluster Innovation Centre",
        "duration":"July 2022 - Nov. 2022",
        "location":"New Delhi,India",
        "body":"E-commerce, powered by mobile technology, reshapes global shopping habits. 'thecart,' an Android app, simplifies online shopping with product sections, banners, tracking, and Firebase data management, fueling the rapid growth of the E-commerce market.",
        // "projectlink":"https://github.com/rajandu/thecart2",
        "user_id":3

    }
      

]
export default internship;